<template>
  <div>
    <span v-for="(tags, type) in computedTagGroups" :key="`group-${type}`">
      <span v-for="(tag, index) in tags" :key="`${tag}-${index}`">
        <action-tag :tag="tag"> </action-tag>
      </span>
    </span>
  </div>
</template>

<script>
import { Tag } from '@/models/transition/transition.js'

export default {
  name: 'ActionTagList',
  props: {
    tags: {
      type: Array,
      required: true
    }
  },
  components: {
    'action-tag': () => import('@/components/transition/ActionTag.vue')
  },
  data: function () {
    return {
      tagGroups: Tag.group(this.tags)
    }
  },
  computed: {
    computedTagGroups: {
      get () {
        return this.tagGroups
      }
    }
  },
  watch: {
    tags: function (value) {
      // v-model change
      this.tagGroups = Tag.group(value)
    }
  }
}
</script>
